export default "__VITE_ASSET__CU43WUd$__"